module.exports = __webpack_public_path__ + "static/media/octagon.8d0d84e9.svg";